module.exports = __webpack_public_path__ + "63f72ee22e74e65bcf8211c6e6ebff3d.svg";